import { createAction, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { Project } from '@shared/project/models';
import { ProjectQueryParams } from '@shared/project/models';

export const privateProjectsPageActions = {
  loadProjects: createAction(
    '[Private Projects Page] Load Projects'
  ),
  loadProjectsSuccess: createAction(
    '[Private Projects Page] Load Projects Success',
    props<{ projects: Array<Project> }>()
  ),
  loadProjectsFailure: createAction(
    '[Private Projects Page] Load Projects Failure',
    props<{ response: HttpErrorResponse }>()
  ),
  changeFilters: createAction(
    '[Private Projects Page] Change Filters',
    props<{ queryParams?: ProjectQueryParams }>()
  ),
  changeSearch: createAction(
    '[Private Projects Page] Change Search',
    props<{ queryParams?: ProjectQueryParams }>()
  ),
  refreshState: createAction(
    '[Private Projects Page] Refresh State'
  )
};
